import { Search } from "@mui/icons-material";
import {
	Box,
	Button,
	CircularProgress,
	InputAdornment,
	List,
	ListItem,
	ListItemText,
	Modal,
	TextField,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ConfirmCompanyModal from "./ConfirmCompanyModal";
import AddCompanyManuallyModal from "./AddCompanyManuallyModal";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 650,
	bgcolor: "background.paper",
	borderRadius: "1rem",
	p: 4,
};

const COMPANY_HOUSE_API_KEY = process.env.REACT_APP_COMPANIES_HOUSE_API_KEY;
const COMPANY_HOUSE_API_URL = process.env.REACT_APP_COMPANY_HOUSE_API_URL;

const AddCompany = ({ showModal, closeModal, fetchCompanies }) => {
	const [search, setSearch] = useState("");
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(false);
	const [selectedCompany, setSelectedCompany] = useState(null);
	const [showConfirmCompanyModal, setShowConfirmCompanyModal] =
		useState(false);
	const [showAddCompanyManuallyModal, setShowAddCompanyManuallyModal] =
		useState(false);

	const debounceRef = useRef(null);

	const fetchCompaniesBySearch = async (query) => {
		setLoading(true);
		try {
			const response = await axios.get(
				`${COMPANY_HOUSE_API_URL}/advanced-search/companies?company_name_includes=${query}`,
				{
					headers: {
						Authorization: COMPANY_HOUSE_API_KEY,
					},
				}
			);
			setItems(response.data.items);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		if (debounceRef.current) clearTimeout(debounceRef.current);

		debounceRef.current = setTimeout(() => {
			if (search) fetchCompaniesBySearch(search);
		}, 500);

		return () => {
			if (debounceRef.current) clearTimeout(debounceRef.current);
		};
	}, [search]);
	return (
		<Modal
			open={showModal}
			onClose={closeModal}
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'>
			<Box sx={style}>
				{showConfirmCompanyModal && (
					<ConfirmCompanyModal
						selectedCompany={selectedCompany}
						setSelectedCompany={setSelectedCompany}
						showModal={showConfirmCompanyModal}
						closeModal={() => setShowConfirmCompanyModal(false)}
						setSearch={setSearch}
						setItems={setItems}
						closeAddCompanyModal={closeModal}
						fetchCompanies={fetchCompanies}
					/>
				)}
				{showAddCompanyManuallyModal && (
					<AddCompanyManuallyModal
						showModal={showAddCompanyManuallyModal}
						closeModal={() => setShowAddCompanyManuallyModal(false)}
						fetchCompanies={fetchCompanies}
						closeAddCompanyModal={closeModal}
					/>
				)}
				<Box sx={{ width: "100%" }}>
					<TextField
						sx={{
							width: "100%",
							"& .MuiOutlinedInput-root": {
								backgroundColor: "transparent",
								"&:hover fieldset": { borderColor: "#ccc" },
								"&.Mui-focused": {
									backgroundColor: "transparent",
									"& fieldset": { borderColor: "#ccc" },
								},
							},
							"& .MuiOutlinedInput-input": {
								outline: "none",
							},
						}}
						variant='outlined'
						size='small'
						placeholder='Search...'
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						InputProps={{
							endAdornment: (
								<InputAdornment position='end'>
									<Search />
								</InputAdornment>
							),
						}}
					/>
				</Box>

				{loading ? (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							margin: "1rem 0",
							alignItems: "center",
						}}>
						<CircularProgress size={24} />
					</Box>
				) : (
					items.length > 0 && (
						<List
							sx={{
								border: "1px solid #ccc",
								borderRadius: 0,
								maxHeight: 200,
								overflowY: "auto",
								padding: 0,
								cursor: "pointer",
							}}>
							{items.map((result, index) => (
								<div
									key={index}
									onClick={() => {
										setSelectedCompany(result);
										setShowConfirmCompanyModal(true);
									}}>
									<ListItem
										sx={{
											"&:hover": {
												backgroundColor: "#f5f5f5",
											},
											borderBottom: "1px solid #ccc",
										}}>
										<ListItemText
											primary={result.company_name}
											secondary={`${result.registered_office_address.address_line_1} ${result.registered_office_address.locality} ${result.registered_office_address.postal_code}`}
										/>
									</ListItem>
								</div>
							))}
						</List>
					)
				)}

				<Button
					startIcon={<AddIcon />}
					onClick={() => setShowAddCompanyManuallyModal(true)}
					sx={{
						border: "1px solid #ccc",
						borderRadius: 0,
						width: "100%",
						display: "flex",
						justifyContent: "start",
						paddingLeft: "1rem",
					}}>
					Add Company Manually
				</Button>
			</Box>
		</Modal>
	);
};

export default AddCompany;
